/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Input} from '@angular/core';
import {coerceBooleanProperty} from '../core/coercion/boolean-property';

/** MdAccordion's display modes. */
export type MdAccordionDisplayMode = 'default' | 'flat';
/**
 * Unique ID counter
 */
let nextId = 0;
/**
 * Directive whose purpose is to manage the expanded state of CdkAccordionItem children.
 */
export class CdkAccordion {
/**
 * A readonly id value to use for unique selection coordination.
 */
readonly id = `cdk-accordion-${nextId++}`;
/**
 * Whether the accordion should allow multiple expanded accordion items simulateously.
 * @return {?}
 */
get multi(): boolean { return this._multi; }
/**
 * @param {?} multi
 * @return {?}
 */
set multi(multi: boolean) { this._multi = coerceBooleanProperty(multi); }
private  _multi: boolean = false;
/**
 * Whether the expansion indicator should be hidden.
 * @return {?}
 */
get hideToggle(): boolean { return this._hideToggle; }
/**
 * @param {?} show
 * @return {?}
 */
set hideToggle(show: boolean) { this._hideToggle = coerceBooleanProperty(show); }
private  _hideToggle: boolean = false;
/**
 * The display mode used for all expansion panels in the accordion. Currently two display
 * modes exist:
 *   default - a gutter-like spacing is placed around any expanded panel, placing the expanded
 *     panel at a different elevation from the reset of the accordion.
 *  flat - no spacing is placed around expanded panels, showing all panels at the same
 *     elevation.
 */
displayMode: MdAccordionDisplayMode = 'default';
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cdk-accordion]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'multi': [{ type: Input },],
'hideToggle': [{ type: Input },],
'displayMode': [{ type: Input },],
};
}

function CdkAccordion_tsickle_Closure_declarations() {
/** @type {?} */
CdkAccordion.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CdkAccordion.ctorParameters;
/** @type {?} */
CdkAccordion.propDecorators;
/**
 * A readonly id value to use for unique selection coordination.
 * @type {?}
 */
CdkAccordion.prototype.id;
/** @type {?} */
CdkAccordion.prototype._multi;
/** @type {?} */
CdkAccordion.prototype._hideToggle;
/**
 * The display mode used for all expansion panels in the accordion. Currently two display
 * modes exist:
 *   default - a gutter-like spacing is placed around any expanded panel, placing the expanded
 *     panel at a different elevation from the reset of the accordion.
 *  flat - no spacing is placed around expanded panels, showing all panels at the same
 *     elevation.
 * @type {?}
 */
CdkAccordion.prototype.displayMode;
}

/**
 * Directive for a Material Design Accordion.
 */
export class MdAccordion extends CdkAccordion {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mat-accordion, md-accordion',
  host: {
    class: 'mat-accordion'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdAccordion_tsickle_Closure_declarations() {
/** @type {?} */
MdAccordion.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdAccordion.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
